import { Domain } from '../domains/domain';
import { StatusCategory } from '../status-categories/status-category';

export class Status {
  public id?: string;
  public name: string;
  public domain?: Domain;
  public category?: StatusCategory;
}
